import * as React from 'react';
import { ColumnAccountEditorGrid } from '../core/ColumnAccountEditorGrid';
import { useAppDispatch, useAppSelector } from '../../hooks/index';
import { updateTableFact, updateVersionStateValue } from '../../redux/AfrSlice';
import enums from '../../utils/enums';
import { getTableFacts } from '../../redux/MiscSlice';


const AffiliatedEntitiesCoreDetail = (props: any) => {
    const dispatch = useAppDispatch();

    // Cell Handler
    const handleCellEdited = function (cell: any) {
        var row = cell.getRow();
        var rowid = row.getData().dimensionCode;
        var accountid = cell.getField();
        var newvalue = cell.getValue();
        dispatch(updateTableFact({
            tableId: enums.tableName.affiliatedEntity,
            rowId: rowid,
            fundGroup: accountid,
            concept: accountid,
            value: newvalue
        }));

    }

    return (
        <React.Fragment>
            <div>
                <ColumnAccountEditorGrid
                    tableName={enums.tableName.affiliatedEntity}
                    gridData={[]}
                    gridColumns={[]}
                    gridOptions={[]}
                    cellEditHandler={handleCellEdited}
                    doneFlag={props.doneFlag}
                    noFlag={props.noFlag}
                />
            </div>
        </React.Fragment>
    );
}

export default AffiliatedEntitiesCoreDetail;